import { useCongressMeta } from "@/features/congress-details/api/get-congress";
import { MigrationModal } from "@/features/congress-details/components/migration-modal";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { Separator } from "./ui/separator";

export function DoMigration() {
  const { t } = useTranslation();
  const { congress } = useCongress();
  const { data: congressMeta, isSuccess } = useCongressMeta(congress.id);

  // this is null intentionally, i want to hide this component
  if (!isSuccess || congressMeta.congId) {
    return null;
  }

  return (
    <div>
      <Alert variant="warning">
        <AlertTitle>{t("common.warning")}</AlertTitle>
        <AlertDescription className="mb-2">
          {t("migration.warning")}
        </AlertDescription>
        <MigrationModal />
      </Alert>
      <Separator className="my-4" />
    </div>
  );
}
